import { Injectable } from '@angular/core';
import { Settings } from '../model/settings.model';
import { ParseAPIService, DbObjectsStore } from '../abstract/ParseAPIService';
import 'parse';
import { DefinitionChecklist } from '../model/definition-checklist.model';
import { Subject } from 'rxjs';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { RoiService } from './roi.service';
import { settings } from 'cluster';

const parse: typeof Parse = require('parse');

@Injectable()
export class ParametersService {
  settingsLinkUser: any;
  settingsLinkCompany: any;
  company: any;
  canEdit: boolean = false;
  canDetection: boolean = false;
  isAdmin: boolean = false;
  isSuperAdmin = parse.User.current() ? (parse.User.current().get('isSuperAdmin') || false) : false
  canSeeConfidence = parse.User.current() ? (parse.User.current().get('canSeeConfidence') || false) : false
  hasUserSettings: boolean = false;
  companyFilter: { type: string, proba: number, number: number }[];
  defaultApiToken: any;
  defaultDashboard: any;
  defaultSettings: any;
  

  private editDamageFilter = new Subject<any>();
  editDamageFilterObs = this.editDamageFilter.asObservable();
  damageFilterEdit() {
    this.editDamageFilter.next()
  }

  constructor(
    private readonly i18n: I18n,
    private readonly _roiService: RoiService
  ) {
    if (parse.User.current().get('settingsPtr'))
      this.hasUserSettings = true;

    this.setValueSettings(
      parse.User.current().get('settingsPtr'),
      parse.User.current().get('companyPtr').get('settingsPtr'));

    this.isSuperAdmin = parse.User.current().get('isSuperAdmin');

    this.defaultDashboard = [
      {
        display: this.i18n({
          id: 'picture',
          value: 'Photo Miniature',
          description: 'Photo Miniature',
          meaning: "contentDashboard"
        }), value: 'picture'
      },
      {
        display: this.i18n({
          id: 'matriculation',
          value: 'Immatriculation du vehicule',
          description: 'Immatriculation du vehicule',
          meaning: "contentDashboard"
        }), value: 'matriculation'
      },
      {
        display: this.i18n({
          id: 'newDamage',
          value: 'Nombre nouveaux de Dommages',
          description: 'Nombre nouveaux de Dommages',
          meaning: "contentDashboard"
        }), value: 'newDamage'
      },
      {
        display: this.i18n({
          id: 'status',
          value: 'Statut du Tchek',
          description: 'Statut du Tchek',
          meaning: "contentDashboard"
        }), value: 'status'
      },
      {
        display: this.i18n({
          id: 'brand',
          value: 'Marque du vehicule',
          description: 'Marque du vehicule',
          meaning: "contentDashboard"
        }), value: 'brand'
      },
      {
        display: this.i18n({
          id: 'model',
          value: 'Modèle du vehicule',
          description: 'Modèle du vehicule',
          meaning: "contentDashboard"
        }), value: 'model'
      },
      {
        display: this.i18n({
          id: 'fre',
          value: 'Frais de remise en état',
          description: 'Frais de remise en état',
          meaning: "contentDashboard"
        }), value: 'fre'
      }];

    this.defaultApiToken = {
      publicKey: '',
      privateKey: '',
      webhook: '',
      headerKey: '',
      vehicle: {
        orNumber: false,
        vinNumber: false,
        classes: [],
        checklist: []
      },
      options: {
        newTchek: false,
        detectionFinished: false,
        detectionFinishedCloud: false,
        sendToSI: false,
      }
    }
    
    this.defaultSettings = {
      language: 'fr',
      style: {
        damageColor: "#FFFFFF", newDamageColor: "#FF0000", dashboard: this.defaultDashboard,
        gamma: 1, contrast: 0, saturation: 0
      },
      notification: {},
      option: {},
      accessibility: { 
        showIcon: false, 
        useFastTrack: false, 
        fastTrackComp: false, 
        showImmatPicture: true, 
        fastTrackZoom: true, 
        fastTrackL1: true, 
        fastTrackL2: true, 
        fastTrackL3: true,
        deleteDamageDuringFTAskReason: true,
        endOfFastTrackSimplified: false
      },
      report: {
        "state": {
          "checklist": true,
          "picturesPreSelected": true,
          "signatory": true,
          "vehicleDetails": true,
          "showCost": true,
          "showSeverity": true,
          "croppImages": false
        },
        "simple": {
          "signatory": true,
          "picturesPreSelected": true,
          "showCost": true,
          "showSeverity": true,
          "vehicleDetails": true,
          "croppImages": false
        },
        "oldDamages": true,
        "checkDamages": true,
        "prefix": "",
        "selectorSens": "clockwise",
        "selectorCost": "sum",
        "selectorReport": "simple",
        "selectorButton": "openpdf",
        "selectorSvg": "renault",
        "selectorSvgColor": "repairSeverity"
      },
      api: this.defaultApiToken,
      cost: [],
      filterDamage: this.defaultFilterDamageOf()
    };
  }

  defaultFilterDamageOf(settingsPtr?): { type: string, proba: number, number: number }[] {
    let settingsValue = [];
    if (settingsPtr) {
      settingsValue = settingsPtr.get('damageFilter') || []
    }

    let defaultValue = [
      {
        "type": "scratch",
        "proba": 50,
        "number": 2
      },
      {
        "type": "bump",
        "proba": 50,
        "number": 1
      },
      {
        "type": "dent",
        "proba": 50,
        "number": 1
      },
      {
        "type": "broken_part",
        "proba": 50,
        "number": 10
      }
    ];

    defaultValue.forEach(d => {
      let index = settingsValue.findIndex(filter => { return d.type === filter.type });
      if (index === -1)
        settingsValue.push(d)
    });

    settingsValue.forEach(f => {
      if (f.number < 1) f.number = 1;
      if (f.proba < 50) f.proba = 50;
    })

    Object.keys(this._roiService.vehicleDamageTypes).filter(name => name !== 'added').forEach(key => {
      let index = settingsValue.findIndex(filter => { return filter.type === key })
      if (index < 0) {
        settingsValue.push({
          "type": key,
          "proba": 50,
          "number": 1
        })
      }
    })
    return settingsValue;
  }


  setValueSettings(user, company) {
    
    this.canEdit = parse.User.current().get('canEdit');
    this.canDetection = parse.User.current().get('canDetection') ? true : false;
    this.company = parse.User.current().get('companyPtr');

    if (!user && !company) {
      this.settingsLinkUser = this.defaultSettings;
      this.settingsLinkCompany = this.defaultSettings;
    }

    if (!company) {
      this.settingsLinkCompany = this.defaultSettings;
    } else {
      try {
        this.settingsLinkCompany = company;
        this.settingsLinkCompany.language = company.get('language') || 'fr';
        this.settingsLinkCompany.style = company.get('style') || {
          damageColor: "#FFFFFF", newDamageColor: "#FF0000",
          dashboard: this.defaultDashboard,
          gamma: 1, contrast: 0, saturation: 0
        };
        if (!this.settingsLinkCompany.style.dashboard)
          this.settingsLinkCompany.style.dashboard = this.defaultDashboard;
        this.settingsLinkCompany.notification = company.get('notification') || {};
        this.settingsLinkCompany.option = company.get('option') || {};
        this.settingsLinkCompany.report = company.get('report') || {
          "state": {
            "checklist": true,
            "picturesPreSelected": true,
            "showCost": true,
            "showSeverity": true,
            "signatory": true,
            "vehicleDetails": true,
            "croppImages": false
          },
          "simple": {
            "signatory": true,
            "picturesPreSelected": true,
            "showCost": true,
            "showSeverity": true,
            "vehicleDetails": true,
            "croppImages": false
          },
          "oldDamages": true,
          "checkDamages": true,
          "prefix": "",
          "selectorCost": "sum",
          "selectorReport": "simple",
          "selectorButton": "openpdf",
          "selectorSens": "clockwise",
          "selectorSvg": "renault",
          "selectorSvgColor": "repairSeverity"
        };
        if (!this.settingsLinkCompany.report.selectorSens)
          this.settingsLinkCompany.report.selectorSens = 'clockwise'
        if (!this.settingsLinkCompany.report.selectorSvg)
          this.settingsLinkCompany.report.selectorSvg = 'renault'
        if (!this.settingsLinkCompany.report.selectorSvgColor)
          this.settingsLinkCompany.report.selectorSvgColor = 'repairSeverity'
        if (!this.settingsLinkCompany.report.simple)
          this.settingsLinkCompany.report.simple = {
            "signatory": true,
            "vehicleDetails": true,
            "picturesPreSelected": true,
            "showCost": true,
            "showSeverity": true,
            "croppImages": false
          };
        if (!this.settingsLinkCompany.report.state)
          this.settingsLinkCompany.report.state = {
            "checklist": true,
            "picturesPreSelected": true,
            "showCost": true,
            "showSeverity": true,
            "signatory": true,
            "vehicleDetails": true,
            "croppImages": false
          };

        this.settingsLinkCompany.users = company.get('users') || {};
        this.settingsLinkCompany.filterDamage = this.defaultFilterDamageOf(company)
        this.settingsLinkCompany.vehicle = company.get('vehicle') || { orNumber: false, vinNumber: false, classes: [] };
        this.settingsLinkCompany.cost = company.get('cost') || [];
        this.settingsLinkCompany.company = company.get('company') || {};
        this.settingsLinkCompany.accessibility = company.get('accessibility') || this.defaultSettings.accessibility;
        this.settingsLinkCompany.companyLogo = company.get('logo') || parse.User.current().get('companyPtr').get('logo') || undefined;
        this.settingsLinkCompany.companyStamp = company.get('stamp') || parse.User.current().get('companyPtr').get('stamp') || undefined;

        if (company.get('APITokenPtr')) {
          this.settingsLinkCompany.api = company.get('APITokenPtr');
          this.settingsLinkCompany.api.publicKey = company.api.get('token') || '';
          this.settingsLinkCompany.api.privateKey = company.api.get('privateKey') || '';
          this.settingsLinkCompany.api.webhook = company.api.get('webhook') || '';
          this.settingsLinkCompany.api.headerKey = company.api.get('headerKey') || '';
          this.settingsLinkCompany.api.options = company.api.get('options') || '';
        } else { this.settingsLinkCompany.api = this.defaultApiToken }
      } catch (e) {
        console.log('error Settings', e)
      }
    }
    try {
      if (!user) {
        this.settingsLinkUser = {};
        this.settingsLinkUser.language = this.copyValue(this.settingsLinkCompany.language);
        this.settingsLinkUser.style = this.copyValue(this.settingsLinkCompany.style);
        if (!this.settingsLinkUser.style.dashboard)
          this.settingsLinkUser.style.dashboard = this.defaultDashboard;
        this.settingsLinkUser.notification = this.copyValue(this.settingsLinkCompany.notification);
        this.settingsLinkUser.option = this.copyValue(this.settingsLinkCompany.option);
        this.settingsLinkUser.report = this.copyValue(this.settingsLinkCompany.report);
        this.settingsLinkUser.users = this.copyValue(this.settingsLinkCompany.users);
        this.settingsLinkUser.accessibility = this.copyValue(this.settingsLinkCompany.accessibility);
        this.settingsLinkUser.filterDamage = this.defaultFilterDamageOf(company);
        this.settingsLinkUser.vehicle = this.copyValue(this.settingsLinkCompany.vehicle);
        this.settingsLinkUser.cost = this.copyValue(this.settingsLinkCompany.cost);
        this.settingsLinkUser.api = this.settingsLinkCompany.api
        this.settingsLinkUser.company = this.copyValue(this.settingsLinkCompany.company);
        this.settingsLinkUser.companyLogo = {
          url: () => { return this.settingsLinkCompany.companyLogo.url() },
          name: () => { return this.settingsLinkCompany.companyLogo.name() }
        };
        this.settingsLinkUser.companyStamp = {
          url: () => { return this.settingsLinkCompany.companyStamp.url() },
          name: () => { return this.settingsLinkCompany.companyStamp.name() }
        };
      } else {
        this.settingsLinkUser = user;
        this.settingsLinkUser.language = user.get('language') || this.copyValue(this.settingsLinkCompany.language);
        this.settingsLinkUser.style = user.get('style') || this.copyValue(this.settingsLinkCompany.style);
        if (!this.settingsLinkUser.style.dashboard)
          this.settingsLinkUser.style.dashboard = this.defaultDashboard;
        this.settingsLinkUser.notification = user.get('notification') || this.copyValue(this.settingsLinkCompany.notification);
        this.settingsLinkUser.option = user.get('option') || this.copyValue(this.settingsLinkCompany.option);
        this.settingsLinkUser.accessibility = user.get('accessibility') || this.copyValue(this.settingsLinkCompany.accessibility);
        this.settingsLinkUser.report = user.get('report') || this.copyValue(this.settingsLinkCompany.report);
        if (!this.settingsLinkUser.report.selectorSens)
          this.settingsLinkUser.report.selectorSens = 'clockwise'
        if (!this.settingsLinkUser.report.selectorSvg)
          this.settingsLinkUser.report.selectorSvg = 'renault'
        if (!this.settingsLinkUser.report.selectorSvgColor)
          this.settingsLinkUser.report.selectorSvgColor = 'repairSeverity'
        if (!this.settingsLinkUser.report.simple)
          this.settingsLinkUser.report.simple = {
            "signatory": true,
            "vehicleDetails": true,
            "picturesPreSelected": true,
            "showCost": true,
            "showSeverity": true,
            "croppImages": false
          };
        if (!this.settingsLinkUser.report.state)
          this.settingsLinkUser.report.state = {
            "checklist": true,
            "picturesPreSelected": true,
            "showCost": true,
            "showSeverity": true,
            "signatory": true,
            "vehicleDetails": true,
            "croppImages": false
          };

        if (this.isSuperAdmin) {
          this.settingsLinkUser.filterDamage = this.defaultFilterDamageOf(user);
        } else this.settingsLinkUser.filterDamage = this.defaultFilterDamageOf(company);

        this.settingsLinkUser.users = user.get('users') || this.copyValue(this.settingsLinkCompany.users);
        this.settingsLinkUser.filterDamage = user.get('damageFilter') ? this.defaultFilterDamageOf(user) : this.defaultFilterDamageOf(company)
        this.settingsLinkUser.vehicle = user.get('vehicle') || this.copyValue(this.settingsLinkCompany.vehicle);
        this.settingsLinkUser.cost = this.copyValue(this.settingsLinkCompany.cost);
        this.settingsLinkUser.api = this.settingsLinkCompany.api
        this.settingsLinkUser.company = user.get('company') || this.copyValue(this.settingsLinkCompany.company);
        this.settingsLinkUser.companyStamp = user.get('stamp') || {
          url: () => { return this.settingsLinkCompany.companyStamp.url() },
          name: () => { return this.settingsLinkCompany.companyStamp.name() }
        };
        this.settingsLinkUser.companyLogo = user.get('logo')
          || {
          url: () => { return this.settingsLinkCompany.companyLogo.url() },
          name: () => { return this.settingsLinkCompany.companyLogo.name() }
        };
      }
    } catch (e) {
      console.log('error Settings', e)
    }
  }

  public copyValue(data: JSON) {
    return (JSON.parse(JSON.stringify(data)))
  }

  settingsOf(settingsPtr) {
    //console.log('///////// run settings of', settingsPtr)
    let settings;

    if (!settingsPtr) {
      settings = this.defaultSettings;
    } else {
      try {
        settings = settingsPtr;
        settings.language = settingsPtr.get('language') || 'fr';
        settings.style = settingsPtr.get('style') || {
          damageColor: "#FFFFFF", newDamageColor: "#FF0000", dashboard: this.defaultDashboard,
          gamma: 1, contrast: 0, saturation: 0
        };
        if (!settings.style.dashboard)
          settings.style.dashboard = this.defaultDashboard;
        settings.notification = settingsPtr.get('notification') || {};
        settings.option = settingsPtr.get('option') || {};
        settings.report = settingsPtr.get('report') || {
          "state": {
            "checklist": true,
            "picturesPreSelected": true,
            "showCost": true,
            "showSeverity": true,
            "signatory": true,
            "vehicleDetails": true,
            "croppImages": false
          },
          "simple": {
            "signatory": true,
            "picturesPreSelected": true,
            "showCost": true,
            "showSeverity": true,
            "vehicleDetails": true,
            "croppImages": false
          },
          "oldDamages": true,
          "checkDamages": true,
          "prefix": "",
          "selectorCost": "sum",
          "selectorReport": "simple",
          "selectorButton": "openpdf",
          "selectorSens": "clockwise",
          "selectorSvg": "renault",
          "selectorSvgColor": "repairSeverity"
        };
        if (!settings.report.selectorSens)
          settings.report.selectorSens = 'clockwise'
        if (settings.report.checkDamages === undefined)
          settings.report.checkDamages = true
        if (!settings.report.selectorSvg)
          settings.report.selectorSvg = 'renault'
        if (!settings.report.selectorSvgColor)
          settings.report.selectorSvgColor = 'repairSeverity'
        if (!settings.report.simple)
          settings.report.simple = {
            "signatory": true,
            "vehicleDetails": true,
            "picturesPreSelected": true,
            "showCost": true,
            "showSeverity": true,
            "croppImages": false
          };
        if (!settings.report.state)
          settings.report.state = {
            "checklist": true,
            "picturesPreSelected": true,
            "showCost": true,
            "showSeverity": true,
            "signatory": true,
            "vehicleDetails": true,
            "croppImages": false
          };

        settings.users = settingsPtr.get('users') || {};
        settings.filterDamage = this.defaultFilterDamageOf(settingsPtr)
        settings.vehicle = settingsPtr.get('vehicle') || { orNumber: false, vinNumber: false, classes: [] };
        settings.cost = settingsPtr.get('cost') || [];
        settings.company = settingsPtr.get('company') || {};
        settings.accessibility = settingsPtr.get('accessibility') || this.defaultSettings.accessibility;
        settings.companyLogo = settingsPtr.get('logo') || undefined;
        settings.companyStamp = settingsPtr.get('stamp') || undefined;

        if (settingsPtr.get('APITokenPtr')) {
          settings.api = settingsPtr.get('APITokenPtr');
          settings.api.publicKey = settingsPtr.api.get('token') || '';
          settings.api.privateKey = settingsPtr.api.get('privateKey') || '';
          settings.api.webhook = settingsPtr.api.get('webhook') || '';
          settings.api.headerKey = settingsPtr.api.get('headerKey') || '';
          settings.api.options = settingsPtr.api.get('options') || '';
        } else { settings.api = this.defaultApiToken }
      } catch (e) {
        console.log('error Settings', e)
      }
    }
    return settings;
  }

  public async saveLanguage(language, company?: boolean): Promise<Settings> {
    try {
      let settings
      if (company)
        settings = this.settingsLinkCompany
      else if (this.hasUserSettings)
        settings = this.settingsLinkUser;
      else
        return this.settingsLinkCompany;

      settings.set("language", language)
      settings.language = language;
      settings.set('toSync', true)

      const savedObjects = await settings.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async saveAccessibility(accessibility, company?: boolean): Promise<Settings> {
    try {
      let settings
      if (company)
        settings = this.settingsLinkCompany
      else if (this.hasUserSettings)
        settings = this.settingsLinkUser;
      else
        return this.settingsLinkCompany;

      settings.set("accessibility", accessibility)
      settings.accessibility = accessibility;
      settings.set('toSync', true)

      const savedObjects = await settings.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public asknewtoken(type: string): Promise<any> {
    return new Promise((resolve, reject) => {
      parse.Cloud.run('newToken', { type }).then(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  public getAll(company?: boolean): Settings {
    if (company)
      return this.settingsLinkCompany
    else
      return this.settingsLinkUser;
  }

  public async savewebhook(form: any): Promise<Settings> {
    try {
      this.settingsLinkCompany.api.set(form)
      if (form.webhook)
        this.settingsLinkCompany.api.webhook = form.webhook;
      if (form.headerKey)
        this.settingsLinkCompany.api.headerKey = form.headerKey;
      if (form.options)
        this.settingsLinkCompany.api.options = form.option;

      this.settingsLinkCompany.set('toSync', true)

      const savedObjects = await this.settingsLinkCompany.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async saveCompany(data, company?: boolean): Promise<Settings> {
    try {
      let settings
      if (company)
        settings = this.settingsLinkCompany
      else if (this.hasUserSettings)
        settings = this.settingsLinkUser;
      else
        return this.settingsLinkCompany;

      console.log(settings);
      settings.set("company", data)
      settings.company = data;
      settings.set('toSync', true)

      const savedObjects = await settings.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async saveFilterDamage(filterDamage): Promise<Settings> {
    try {
      let settings = this.settingsLinkUser
      if (this.hasUserSettings !== true) return
      console.log("update save filter ", filterDamage)
      settings.set("damageFilter", filterDamage)
      settings.filterDamage = filterDamage;
      settings.set('toSync', true)

      const savedObjects = await settings.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async saveCompanyLogo(data, company?: boolean): Promise<Settings> {
    try {
      let settings
      if (company)
        settings = this.settingsLinkCompany
      else if (this.hasUserSettings)
        settings = this.settingsLinkUser;
      else
        return this.settingsLinkCompany;
      let parseFile = new parse.File(data.name, data);
      settings.set("logo", parseFile)
      settings.companyLogo = parseFile;
      settings.set('toSync', true)

      const savedObjects = await settings.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async saveCompanyStamp(data, company?: boolean): Promise<Settings> {
    try {
      let settings
      if (company)
        settings = this.settingsLinkCompany
      else if (this.hasUserSettings)
        settings = this.settingsLinkUser;
      else
        return this.settingsLinkCompany;
      let parseFile = new parse.File(data.name, data);
      settings.set("stamp", parseFile)
      settings.companyStamp = parseFile;
      settings.set('toSync', true)

      const savedObjects = await settings.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async saveStyle(style, company?: boolean): Promise<Settings> {
    try {
      let settings
      if (company)
        settings = this.settingsLinkCompany
      else if (this.hasUserSettings)
        settings = this.settingsLinkUser;
      else
        return this.settingsLinkCompany;

      settings.set('toSync', true)
      settings.set("style", style)
      settings.style = style;
      const savedObjects = await settings.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async saveReport(report, company?: boolean): Promise<Settings> {
    try {
      let settings;
      if (company)
        settings = this.settingsLinkCompany
      else if (this.hasUserSettings)
        settings = this.settingsLinkUser;
      else
        return this.settingsLinkCompany;
      settings.set("report", report)
      settings.report = report;
      settings.set('toSync', true)

      const savedObjects = await settings.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async saveVehicle(vehicle, company?: boolean): Promise<Settings> {
    try {
      let settings;
      if (company)
        settings = this.settingsLinkCompany
      else if (this.hasUserSettings)
        settings = this.settingsLinkUser;
      else
        return this.settingsLinkCompany;
      settings.set("vehicle", vehicle)
      settings.set('toSync', true)

      settings.vehicle = vehicle;
      const savedObjects = await settings.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async saveCost(cost, company?: boolean): Promise<Settings> {
    try {
      let settings;
      if (company)
        settings = this.settingsLinkCompany
      else if (this.hasUserSettings)
        settings = this.settingsLinkUser;
      else
        return this.settingsLinkCompany;
      settings.set("cost", cost)
      settings.cost = cost;
      settings.set('toSync', true)

      const savedObjects = await settings.save();
      this.setValueSettings(
        parse.User.current().get('settingsPtr'),
        parse.User.current().get('companyPtr').get('settingsPtr'));
      return savedObjects;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/service/parameters.service.ts